import { Page } from '../theme/elements/Page';

export const HomeApp = () => {
	return (
		<Page>
			<>Welcome back</>
		</Page>
	);
};
